import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
} from "react-bootstrap"; 
// import "./TMASection.css";

const services = [
  {
    title: "Industrial Entrepreneur Memorandum (IEM)",
    link: "/dgft/iem",
  },
  {
    title: "RCMCs (Registration Cum Membership Certificate)",
    link: "/dgft/rcmc",
  },
  {
    title: "DGFT Digital Signature (E-Token)",
    link: "/dgft/token",
  },
  {
    title: "Transport And Marketing Assistance (TMA)",
    link: "/dgft/tma",
  },
  {
    title: "Steel Import Monitoring System",
    link: "/dgft/sims",
  },
  {
    title: "Coal Import Monitoring System",
    link: "/dgft/cims",
    },
    {
        title: "Chip Import Monitoring System",
        link:"/dgft/chip",
    },
    {
        title: "Copper/Aluminium Import Monitoring System",
        link:"/dgft/caims",
  },
    {
      title: "Certificate Of Origin",
      link:"/dgft/coo",
    },
    {
        title: "Paper Import Monitoring System",
        link:"/dgft/pims",
    }
];

export default function COO() {
  return (
      <section className="tma-section">
          <Container>
      <div className="container">

        <h1 className="tma-title">
          TRANSPORT AND MARKETING ASSISTANCE SCHEME (TMA)
        </h1>

        <div className="tma-grid">
          {services.map((item, index) => (
            <Link to={item.link} className="tma-card" key={index}>
              <h4>{item.title}</h4>
            </Link>
          ))}
        </div>

              </div>
        </Container>
    </section>
  );
}